// extracted by mini-css-extract-plugin
export default {"about":"AboutPage_about__FgacU"};